export default "__VITE_ASSET__CHPUJ47n__"